<template>
  <div>
    <h3>{{ $t('message.script_config_license') | title }}</h3>

    <div v-if="willRunOnEachClusterNode" class="cluster-info">
      {{ $t('message.will_run_on_each_cluster_node') | title }}
    </div>
    <div v-if="willRunOnThisClusterNodeOnly" class="cluster-info">
      {{ $t('message.will_run_on_this_cluster_node_only') | title }}
    </div>

    <div v-if="currentLicenseData">
      <b-row>
        <b-col cols="3" offset="4">
          <strong>{{$t("message.license_current")}}</strong>
        </b-col>
        <b-col cols="3">
          <strong>{{$t("message.license_new")}}</strong>
        </b-col>
      </b-row>
      <b-row>
        <label class="label label-default col-4">{{$t("message.license_expiry") | title}}</label>
        <b-col cols="3">{{currentLicenseData.exp_str}}</b-col>
        <b-col cols="3" v-if="newLicenseData">{{newLicenseData.exp_str}}</b-col>
      </b-row>
      <b-row>
        <label class="label label-default col-4">{{$t("message.license_software_update_till") | title}}</label>
        <b-col cols="3">{{currentLicenseData.software_update_till_str}}</b-col>
        <b-col cols="3" v-if="newLicenseData">{{newLicenseData.software_update_till_str}}</b-col>
      </b-row>
      <b-row>
        <label class="label label-default col-4">{{$t('message.license_user_count') | title}}</label>
        <b-col cols="3">{{currentLicenseData.user_count}}</b-col>
        <b-col cols="3" v-if="newLicenseData">{{newLicenseData.user_count}}</b-col>
      </b-row>
      <b-row>
        <label class="label label-default col-4">{{$t('message.license_target_count') | title}}</label>
        <b-col cols="3">{{currentLicenseData.target_count_limit}}</b-col>
        <b-col cols="3" v-if="newLicenseData">{{newLicenseData.target_count_limit}}</b-col>
      </b-row>
      <b-row>
        <label class="label label-default col-4">{{$t('message.license_account_count') | title}}</label>
        <b-col cols="3">{{currentLicenseData.account_count_limit}}</b-col>
        <b-col cols="3" v-if="newLicenseData">{{newLicenseData.account_count_limit}}</b-col>
      </b-row>
      <b-row>
        <label class="label label-default col-4">{{$t('message.license_session_management_support') | title}}</label>
        <b-col cols="3">
          <span v-if="currentLicenseData.session_management_support">{{$t("message.status_true")}}</span>
          <span v-else>{{$t("message.status_false")}}</span>
        </b-col>
        <b-col cols="3" v-if="newLicenseData">
          <span v-if="newLicenseData.session_management_support">{{$t("message.status_true")}}</span>
          <span v-else>{{$t("message.status_false")}}</span>
        </b-col>
      </b-row>
      <b-row>
        <label class="label label-default col-4">{{$t('message.license_session_management_session_count') | title}}</label>
        <b-col cols="3">{{currentLicenseData.session_management_session_count}}</b-col>
        <b-col cols="3" v-if="newLicenseData">{{newLicenseData.session_management_session_count}}</b-col>
      </b-row>
    </div>

    <b-form>
      <b-form-row v-if="!newLicenseData">
        <label class="label label-default col-3">
          <span>{{$t("message.license_new") | title}}</span>
        </label>
        <span class="col">
          <b-form-textarea v-model="license" :rows="7" :required="true" :disabled="licenseFile"
            :placeholder="$t('message.none_or_no_change')"/>
        </span>
      </b-form-row>
      <b-form-row v-if="!newLicenseData">
        <label class="label label-default col-3">
          <span>{{$t("message.license_new_file") | title}}</span>
        </label>
        <span class="col">
          <b-form-file v-model="licenseFile" :disabled="license!=null && license != ''"
            :state="Boolean(licenseFile)" :placeholder="$t('message.file_upload_placeholder')"
            :browse-text="$t('message.file_upload_browse_button')"/>
        </span>
      </b-form-row>
      <b-button v-if="!newLicenseData" class="padmin-button" @click="checkNewLicense"
        :disabled="checkDisabled">
        {{$t('message.button_check') | title}}
      </b-button>
      <b-button v-if="newLicenseData" class="padmin-button" :disabled="saveInProgress" @click="cancel">
        {{$t('message.button_cancel') | title}}
      </b-button>
      <b-button class="padmin-button submit-button" :disabled="saveDisabled" @click="save">
        <b-spinner v-if="saveInProgress" small type="grow"/>
        {{$t('message.button_save') | title}}
      </b-button>
      <b-button v-if="initConfig && initConfig.state == 'license set'" type="button"
        class="padmin-button next-button right" :disabled="saveInProgress" @click="next">
        {{$t('message.button_next') | title}}
      </b-button>
    </b-form>

    <b-alert v-model="showError" variant="danger" dismissible @dismissed="error=''; showError=false;">
      <div v-html="error"> </div>
      <div v-if="errorRemark"> {{ errorRemark }}</div>
    </b-alert>

    <ConsoleOutput v-if="result != null" :result="result" :output="output"/>
  </div>
</template>

<script>
import { get, post } from '../http'
import ConsoleOutput from './ConsoleOutput'
import { EventBus } from "../event-bus.js"

export default {
  name: 'LicenseConfig',

  components: { ConsoleOutput },

  data () {
    return {
      license: null,
      licenseFile: null,
      result: null,
      output: '',
      saveInProgress: false,
      error: null,
      errorRemark: null,
      showError: false,
      currentLicenseData: null,
      newLicenseData: null,
      initConfig:null,
      saved: false
    }
  },

  mounted () {
    this.load()
  },

  computed: {
    saveDisabled() {
      return this.saved && (this.saveInprogress || (this.licenseFile == null && this.license == null))
    },
    checkDisabled() {
      return this.saveInprogress || (this.licenseFile == null && this.license == null)
    }
  },

  methods: {
    loadInitConfig() {
      get('/init').then(
        resp => {
          this.initConfig = resp.data;
        },
        err => {
          console.log("err", err)
        }
      )
    },

    loadCurrentLicense () {
      this.showError = false
      this.error = ''
      this.newLicenseData = null
      this.license = null
      this.licenseFile = null

      get('/current_license_data').then(
        resp => {
          this.willRunOnEachClusterNode = resp.data.will_run_on_each_cluster_node
          this.willRunOnThisClusterNodeOnly = resp.data.will_run_on_this_cluster_node_only
          if (resp.data.data) {
            this.currentLicenseData = resp.data.data
          }
          if (resp.data.error) {
            this.error = this.$t('message.error_' + resp.data.error)
            this.showError = true
          }
        },
        err => {
          console.log('err', err)
        }
      )
    },

    load() {
      this.loadCurrentLicense()
      this.loadInitConfig()
    },

    checkNewLicense () {
      this.showError = false
      this.error = ''
      this.saveInProgress = true

      const formData = new FormData()
      if(this.license) {
        formData.append('license', this.license)
      }
      if (this.licenseFile) {
        formData.append('license', this.licenseFile)
      }

      post('/license_data', formData, {"content-type": "multipart/form-data"}).then(
        resp => {
          this.saveInProgress = false
          if (resp.data.data) {
            this.newLicenseData = resp.data.data
          }
          if (resp.data.error) {
            this.error = this.$t('message.error_' + resp.data.error)
            this.showError = true
          }
        },
        err => {
          console.log('err', err)
          this.saveInProgress = false
        }
      )
    },

    cancel () {
      this.license = null
      this.licenseFile = null
      this.newLicenseData = null
      this.error = ''
      this.showError = false
    },

    save () {
      this.result = null
      this.output = ''
      this.saveInProgress = true
      this.showError = false
      this.error = ''

      const formData = new FormData()
      if (this.license) {
        formData.append('license', this.license)
      }
      if (this.licenseFile) {
        formData.append('license', this.licenseFile)
      }

      post('/scripts/config/license', formData, {"content-type": "multipart/form-data"}).then(
        resp => {
          this.saveInProgress = false
          this.output = resp.data.output
          this.result = resp.data.result
          this.errorRemark = null
          this.saved = true
          this.loadInitConfig()

          if (resp.data.error) {
            this.showError = true
            if (resp.data.error.startsWith('ERROR')) {
              this.error = resp.data.error.substring(7)
            } else {
              this.error = this.$t('message.error_' + resp.data.error)
            }
          } else {
            this.error = null
            this.showError = false
            this.loadCurrentLicense()
          }
        },
        err => {
          this.saveInProgress = false
        }
      )
    },
    next() {
      EventBus.$emit('progress init')
    }
  }
}
</script>
